import service from '@/utils/server';

const modName='/int/hikVehicleExit/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};




// WEBPACK FOOTER //
// ./src/page/int/hikVehicleExit/api/index.js